"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return value === null;
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isNull.js
// module id = 2450
// module chunks = 0